import audioRecorderProjectsData from "./projects/audio-recorder.projects.data";
import calculatorProjectsData from "./projects/calculator.projects.data";
import chemistryProjectsData from "./projects/chemistry.projects.data";
import consoleProjectsData from "./projects/console.projects.data";
import davidsimakDevProjectsData from "./projects/davidsimak-dev.projects.data";
import devToolsProjectsData from "./projects/dev-tools.projects.data";
import formulaSolverProjectsData from "./projects/formula-solver.projects.data";
import identityProjectsData from "./projects/identity.projects.data";
import noticeBoardProjectsData from "./projects/notice-board.projects.data";
import reportingApiProjectsData from "./projects/reporting-api.projects.data";
import soundMeterProjectsData from "./projects/sound-meter.projects.data";

class Projects {
  getAllProjects() {
    return [
      audioRecorderProjectsData.getAsItem(),
      calculatorProjectsData.getAsItem(),
      chemistryProjectsData.getAsItem(),
      consoleProjectsData.getAsItem(),
      // davidsimakDevProjectsData.getAsItem(),
      formulaSolverProjectsData.getAsItem(),
      identityProjectsData.getAsItem(),
      noticeBoardProjectsData.getAsItem(),
      reportingApiProjectsData.getAsItem(),
      soundMeterProjectsData.getAsItem(),
      devToolsProjectsData.getAsItem(),
    ];
  }

  getCategoryOfProjects(category) {}

  getProjectDetails(projectName) {
    switch (projectName) {
      case "formula-solver":
        return formulaSolverProjectsData.get();
      case "sound-meter":
        return soundMeterProjectsData.get();
      case "audio-recorder":
        return audioRecorderProjectsData.get();
      case "calculator":
        return calculatorProjectsData.get();
      case "chemistry":
        return chemistryProjectsData.get();
      case "davidsimak-dev":
        return davidsimakDevProjectsData.get();
      case "dev-tools":
        return devToolsProjectsData.get();
      case "identity":
        return identityProjectsData.get();
      case "notice-board":
        return noticeBoardProjectsData.get();
      case "reporting-api":
        return reportingApiProjectsData.get();
      case "console":
        return consoleProjectsData.get();
      default:
        window.location.href = "https://www.davidsimak.dev/error/not-found";
        break;
    }
  }
}

export default new Projects();
